<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <main id="renew3_mypage">
      <div class="mypage_back mypage_yagioffer">
        <div class="wrapper">
          <h2 class="m-h2">マイページ</h2>
          <p class="m-lead">マイページが新しくなりました。データバックアップ・復旧機能を利用したい場合は、<a href="/oldmypage" target="_blank"
              class="text-link">旧マイページ</a>にアクセスしてください。</p>

          <div class="my-contents sp">

            <mypagemenu-item viewFlag="my"></mypagemenu-item>

            <!--contents-->
            <div class="my-contents_container">
              <h2 class="m-h2">ヤギオファー</h2>
              <p class="m-lead">採用を行なっている会社からオファーが届きます。<br>
                ※名前や住所等の個人情報はオファーを承諾するまで求人会社は見ることができません。<br>
                ※オファーを受けたくない場合は <a href="" class="text-link">こちら</a>
              </p>
              <div class="flex offer">
                <a :href="chatURL" v-if="chatURL && yagiOfferData.offer_list.length > 0" target="_blank"
                  class="offer_btn">企業とのチャット</a>
                <a href="/mypage/yagiprime" class="offer_btn">エージェントを利用</a>
              </div>


              <ul class="list">
                <li class="item" v-for="(item, index) in yagiOfferData.offer_list" :key="index">
                  <div class="flex list_wrap">
                    <div class="item01">
                      <div class="flex item01-top">
                        <p class="item01-01">{{ item.offer_date }}</p>
                        <p v-if="item.offer_status == 'accept'" class="item01-02" style="background: #E95B10;">承認</p>
                        <p v-else-if="item.offer_status == 'refuse'" class="item01-02" style="background: #DFDFDF;">辞退
                        </p>
                        <p v-else class="item01-02" style="background: #404040;">未定</p>
                      </div>
                      <p class="item01-bottom">{{ item.company_name }}<span v-for="(m_item, m_index) in
                            yagiOfferUnreadmessageList"
                          v-if="item.offer_status == 'accept' && m_item.id == item.company_uid" class="message-count">{{
    m_item.unreadCount }}</span></p>
                    </div>
                    <div class="item02 yagish-service"
                      @click="!item.detail_display ? item.detail_display = true : item.detail_display = false; openYagiOfferDetailDialog(item.offer_id, '0')">
                      <a class="item02-01">確認する</a>
                    </div>
                  </div>

                  <!--アコーディオン開-->
                  <div class="item03" v-if="false">
                    <p class="item01-01">企業名</p>
                    <p class="item01-bottom">{{ item.company_name }}</p>
                    <p class="item03-01">
                      {{ (item.offer_message) }}
                    </p>

                  </div>
                  <!--アコーディオン開-->
                  <div class="item03" v-if="item.detail_display">
                    <p class="item01-01">企業名</p>
                    <p class="item01-bottom">{{ item.company_name }}</p>
                    <p class="item03-01">
                      {{ (item.offer_message) }}
                    </p>

                    <div class="flex item03-04">
                      <a :href="item.company_url" target="_blank" class="y-link">企業HP</a>
                      <a v-if="item.offer_attach_link1" :href="item.offer_attach_link1" class="y-link"
                        target="_blank">添付した資料</a>
                      <a v-if="item.offer_attach_link2" :href="item.offer_attach_link2" class="y-link"
                        target="_blank">添付した資料</a>
                      <a v-if="item.offer_attach_link3" :href="item.offer_attach_link3" class="y-link"
                        target="_blank">添付した資料</a>
                    </div>

                    <div class="item03-05">
                      <img v-if="item.company_logo" :src="item.company_logo" alt="ヤギオファー企業画像">
                    </div>

                    <el-button v-if="item.offer_status == 'send'" id="submit_offer" type="success" class="item03-02"
                      @click="submitOffer(item.offer_id)">まずは話を聞いてみる</el-button>
                    <el-button v-if="item.offer_status == 'send'" id="deny_offer" type="success" class="item03-03"
                      @click="denyOffer(item.offer_id)">辞退する</el-button>

                  </div>
                </li>
              </ul>


            </div>

            <mypagemenu-item viewFlag="service"></mypagemenu-item>

          </div>

          <div class="my-contents pc flex">
            <div class="menu-column">

              <mypagemenu-item viewFlag="my"></mypagemenu-item>

              <mypagemenu-item viewFlag="service"></mypagemenu-item>
            </div>

            <div class="right-contents">
              <!--contents-->
              <div class="my-contents_container">
                <h2 class="m-h2">ヤギオファー</h2>
                <p class="m-lead">採用を行なっている会社からオファーが届きます。<br>
                  ※名前や住所等の個人情報はオファーを承諾するまで求人会社は見ることができません。<br>
                  ※オファーを受けたくない場合は <a href="" class="text-link">こちら</a>
                </p>

                <div class="flex offer">
                  <a :href="chatURL" v-if="chatURL && yagiOfferData.offer_list.length > 0" target="_blank"
                    class="offer_btn">企業とのチャット</a>
                  <a href="/mypage/yagiprime" class="offer_btn">エージェントを利用</a>
                </div>


                <ul class="list">
                  <li class="item" v-for="(item, index) in yagiOfferData.offer_list" :key="index">
                    <div class="flex list_wrap">
                      <div class="item01">
                        <div class="flex item01-top">
                          <p class="item01-01">{{ item.offer_date }}</p>
                          <p v-if="item.offer_status == 'accept'" class="item01-02" style="background: #E95B10;">承認</p>
                          <p v-else-if="item.offer_status == 'refuse'" class="item01-02" style="background: #DFDFDF;">辞退
                          </p>
                          <p v-else class="item01-02" style="background: #404040;">未定</p>
                        </div>
                        <p class="item01-bottom">{{ item.company_name }}<span v-for="(m_item, m_index) in
                            yagiOfferUnreadmessageList"
                            v-if="item.offer_status == 'accept' && m_item.id == item.company_uid"
                            class="message-count">{{ m_item.unreadCount }}</span></p>
                      </div>
                      <div class="item02 yagish-service"
                        @click="!item.detail_display ? item.detail_display = true : item.detail_display = false; openYagiOfferDetailDialog(item.offer_id, '0')">
                        <a class="item02-01">確認する</a>
                      </div>
                    </div>

                    <!--アコーディオン開-->
                    <div class="item03" v-if="false">
                      <p class="item01-01">企業名</p>
                      <p class="item01-bottom">{{ item.company_name }}</p>
                      <p class="item03-01">
                        {{ (item.offer_message) }}
                      </p>

                    </div>
                    <!--アコーディオン開-->
                    <div class="item03" v-if="item.detail_display">
                      <p class="item01-01">企業名</p>
                      <p class="item01-bottom">{{ item.company_name }}</p>
                      <p class="item03-01">
                        {{ (item.offer_message) }}
                      </p>

                      <div class="flex item03-04">
                        <a :href="item.company_url" target="_blank" class="y-link">企業HP</a>
                        <a v-if="item.offer_attach_link1" :href="item.offer_attach_link1" class="y-link"
                          target="_blank">添付した資料</a>
                        <a v-if="item.offer_attach_link2" :href="item.offer_attach_link2" class="y-link"
                          target="_blank">添付した資料</a>
                        <a v-if="item.offer_attach_link3" :href="item.offer_attach_link3" class="y-link"
                          target="_blank">添付した資料</a>
                      </div>

                      <div class="item03-05">
                        <img v-if="item.company_logo" :src="item.company_logo" alt="ヤギオファー企業画像">
                      </div>

                      <el-button v-if="item.offer_status == 'send'" id="submit_offer" type="success" class="item03-02"
                        @click="submitOffer(item.offer_id)">まずは話を聞いてみる</el-button>
                      <el-button v-if="item.offer_status == 'send'" id="deny_offer" type="success" class="item03-03"
                        @click="denyOffer(item.offer_id)">辞退する</el-button>

                    </div>
                  </li>
                </ul>

              </div>

            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>


<style lang="css" src="@/assets/css/renew3_mypage.css"></style>

<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'
import MypageCommonMenu from '@/components/formats/CommonParts/MypageCommonMenu'

export default {
  components: {
    'mypagemenu-item': MypageCommonMenu,
    'login-forms': LoginForms
  },
  data: function () {
    return {
      fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      dialogVisible: false,
      selectedYagiOfferData: {},
      yagiOfferData: [],
      previewLoading: false,
      yagiOfferUnreadmessageList: [],
      chatURL: ''
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    autoLink: function (text) {
      return text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'>$1</a>");
    },
    openYagiOfferDetailDialog: function (offer_id, read_flag) {
      const app = this
      if (read_flag != '1') {
        const app = this
        const formData = new FormData()
        formData.append('offer_id', offer_id)
        formData.append('uuid', app.$firebase.user.uid)

        this.$axios
          .post(this.$varuna.endPoints.readYagiOffer, formData, { timeout: 60000 })
          .then(function (response) {
            for (let _item of app.yagiOfferData.offer_list) {
              if (_item.offer_id == offer_id) {
                _item.read_flag = '1'
              }
            }
          })
          .catch(function (error) { })
          .finally(function () { })
      }
    },
    submitOffer: function (offer_id) {
      const app = this
      const formData = new FormData()
      formData.append('offer_id', offer_id)
      formData.append('uuid', app.$firebase.user.uid)

      this.$axios
        .post(this.$varuna.endPoints.submitYagiOffer, formData, { timeout: 60000 })
        .then(function (response) {
          for (let _item of app.yagiOfferData.offer_list) {
            if (_item.offer_id == offer_id) {
              _item.offer_status = 'accept'
            }
          }
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーを承認しました`,
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーの承認処理を失敗しました`,
            type: 'error'
          })
        }).finally(function () {

        })
      console.error(this.selectedYagiOfferData.offer_id)
    },
    denyOffer: function (offer_id) {
      const app = this
      const formData = new FormData()
      formData.append('offer_id', offer_id)
      formData.append('uuid', app.$firebase.user.uid)

      this.$axios
        .post(this.$varuna.endPoints.denyYagiOffer, formData, { timeout: 60000 })
        .then(function (response) {
          for (let _item of app.yagiOfferData.offer_list) {
            if (_item.offer_id == offer_id) {
              _item.offer_status = 'refuse'
            }
          }
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーを辞退しました`,
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーの辞退処理を失敗しました`,
            type: 'error'
          })
        }).finally(function () {

        })
      console.error(this.selectedYagiOfferData.offer_id)
    }
  },
  created: function () {
    const app = this
    // console.log(this.$route.query.mynavi)
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        console.log('logined')
        const formData = new FormData()
        formData.append('access_id', '')
        formData.append('uuid', app.$firebase.user.uid)
        formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
        formData.append('version', '2')
        formData.append('reqflg', '2')
        this.$axios
          .post(this.$varuna.endPoints.getYagiOfferList, formData, { timeout: 60000 })
          .then(function (response) {
            app.yagiOfferData = response.data
          })

        this.$axios
          .post(this.$varuna.endPoints.getMessageBox, formData, { timeout: 60000 })
          .then(function (response) {
            app.yagiOfferUnreadmessageList = response.data.unreadcnts.data.companyList
            app.chatURL = response.data.chat_url
            console.error(app.chatURL)
          })
        this.fullscreenLoading = false

      } else {
        this.$router.push('/login')
      }
    })
  },
  beforeMount: function () {
  },
  destroyed: function () {
  }
}
</script>
